import api from "../../utils/API";

const getAllTypesMissionForSelect = () => {
  return api.get(`/gestion/typesmissionforselect/list`);
};

export {getAllTypesMissionForSelect};
